import * as React from 'react';
import withStyles, { WithStyles, StyleRules, ClassNameMap } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles';

import {Paper} from '@material-ui/core';
import {Typography} from '@material-ui/core';

const styles = (theme:Theme):StyleRules => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing(2), //.unit * 3,
    marginBottom: theme.spacing(2), //.unit * 3,
    border: "1px solid #ccc"
  }),
  appBarButton:{}
})

interface Props extends React.HTMLProps<HTMLDivElement>{
  text: string
  headlineText?: string
  elevation?: number
}

type State = {
};

class EmptySet extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  constructor(props:Props & WithStyles<keyof typeof styles>) {
    super(props)
    this.state = {}; 
  }

  render () {


    const { classes }: { classes:ClassNameMap } = this.props
    const { text, headlineText } = this.props

    return (
        <Paper className={classes.root} elevation={this.props.elevation || 0}>
          <Typography variant="h5" component="h4">
            {headlineText || ""}
          </Typography>
          <Typography component="p">
            {text}
          </Typography>
        </Paper>
    );
  }
}

export default withStyles(styles)(EmptySet);
